import { render } from "./TransferModal.vue?vue&type=template&id=8a2427d0&scoped=true"
import script from "./TransferModal.vue?vue&type=script&lang=js"
export * from "./TransferModal.vue?vue&type=script&lang=js"

import "./TransferModal.vue?vue&type=style&index=0&id=8a2427d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a2427d0"]])

export default __exports__